import React from "react";
import styles from "../statics/styles/file-upload-viewer-scss";
const FolderIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "40", height: "42", viewBox: "0 0 40 42", ...props }, /* @__PURE__ */ React.createElement("g", { className: styles.file_upload_icon_frame, fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M1.716 36.29V8.726a1 1 0 0 1 1-1h.003l13.104.039c.307 0 .597.143.786.385l3.812 4.888c.189.243.48.385.788.385h16.072a1 1 0 0 1 1 1V36.29H1.716z"
  }
), /* @__PURE__ */ React.createElement("path", { d: "M1.656 13.431h19.826" })));
export {
  FolderIcon
};
//# sourceMappingURL=folder-icon.js.map
